/* eslint-disable showpass-custom/no-hardcoded-colors */
/* eslint-disable showpass-custom/no-hardcoded-style-values */
import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Google({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Google.Outline {...props} /> : <Google.Solid {...props} />;
}

Google.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Google.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <g fillRule="nonzero">
        <path
          d="M14.3733736,7.500002 C14.3733736,6.980002 14.3266736,6.480002 14.2400736,6.000002 L7.33337358,6.000002 L7.33337358,8.836662 L11.2800736,8.836662 C11.1100736,9.753352 10.5933736,10.529952 9.81667358,11.049952 L9.81667358,12.889952 L12.1866736,12.889952 C13.5733736,11.613352 14.3733736,9.733352 14.3733736,7.500002 Z"
          fill="#4285F4"
        />
        <path
          d="M7.33336358,14.666552 C9.31336358,14.666552 10.9733736,14.009852 12.1866736,12.889852 L9.81667358,11.049852 C9.16003358,11.489852 8.32002358,11.749852 7.33336358,11.749852 C5.42336358,11.749852 3.80669358,10.459852 3.23002358,8.726562 L0.780033575,8.726562 L0.780033575,10.626552 C1.98669358,13.023252 4.46669358,14.666552 7.33336358,14.666552 Z"
          fill="#34A853"
        />
        <path
          d="M3.23000358,8.726702 C3.08333358,8.286702 3,7.816702 3,7.333372 C3,6.850042 3.08333358,6.380042 3.23000358,5.940042 L3.23000358,4.040042 L0.780003575,4.040042 C0.266666575,5.061942 -0.00045242479,6.189782 0,7.333372 C0,8.516702 0.283333575,9.636752 0.780003575,10.626752 L3.23000358,8.726702 Z"
          fill="#FBBC05"
        />
        <path
          d="M7.33336358,2.916662 C8.41002358,2.916662 9.37667358,3.286662 10.1366736,4.013332 L12.2400736,1.910002 C10.9700736,0.726662 9.31003358,0 7.33336358,0 C4.46669358,0 1.98669358,1.643332 0.780033575,4.040002 L3.23002358,5.940002 C3.80669358,4.206662 5.42336358,2.916662 7.33336358,2.916662 Z"
          fill="#EA4335"
        />
      </g>
    ),
  });

  return (
    <Icon
      w="element.xl"
      h="element.xl"
      viewBox="0 0 16 16"
      {...validateKeys(props)}
    />
  );
};
